import React from 'react';
import PropTypes from 'prop-types';

function PlayOutlineIcon(props) {
  const { color = 'currentColor', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="96"
      height="96"
      viewBox="0 0 96 96"
      {...rest}
    >
      <defs>
        <path id="play-circle-outline" d="M17.609 10.026L0 0v19.5z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle
          cx="48"
          cy="48"
          r="46"
          fill="#000"
          fillOpacity="0.1"
          stroke={color}
          strokeWidth="4"
        />
        <g transform="translate(42.375 37.75)">
          <mask id="play-circle-outline-mask" fill={color}>
            <use xlinkHref="#play-circle-outline" />
          </mask>
          <use fill={color} xlinkHref="#play-circle-outline" />
          <g fill={color} mask="url(#play-circle-outline-mask)">
            <path d="M-11.375-9.75h39v39h-39z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

PlayOutlineIcon.propTypes = {
  color: PropTypes.string,
};

export default React.memo(PlayOutlineIcon);
